import { render, staticRenderFns } from "./ActivationBriefAssetsRouterView.vue?vue&type=template&id=01716990&"
import script from "./ActivationBriefAssetsRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAssetsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports